import { Module } from 'vuex';
import { ImagePreviewState, RootState } from '@/store/state_models';

export const imagePreview: Module<ImagePreviewState, RootState> = {
    namespaced: true,
    state: {
        src: ''
    },
    getters: {
        get: (state: ImagePreviewState) => {
            return state;
        },
    },
    mutations: {
        show: (state: ImagePreviewState, src: string) => {
            state.src = src;
        },
        hide: (state: ImagePreviewState) => {
            state.src = '';
        },
    },
};
